var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.25C1 1.55859 1.53066 1 2.1875 1H16.4375C17.0943 1 17.625 1.55859 17.625 2.25C17.625 2.94141 17.0943 3.5 16.4375 3.5H2.1875C1.53066 3.5 1 2.94141 1 2.25ZM3.375 8.5C3.375 7.80859 3.90566 7.25 4.5625 7.25H18.8125C19.4693 7.25 20 7.80859 20 8.5C20 9.19141 19.4693 9.75 18.8125 9.75H4.5625C3.90566 9.75 3.375 9.19141 3.375 8.5ZM17.625 14.75C17.625 15.4414 17.0943 16 16.4375 16H2.1875C1.53066 16 1 15.4414 1 14.75C1 14.0586 1.53066 13.5 2.1875 13.5H16.4375C17.0943 13.5 17.625 14.0586 17.625 14.75Z",
    fill: "#2563eb",
    stroke: "#2563eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedActive);
export default __webpack_public_path__ + "static/media/feed-active.b9240cee4b9f7481371d6af74a1618a8.svg";
export { ForwardRef as ReactComponent };